import { EncryptionsAccessLogDetailTypeEntity } from '../entities';
import { authResource } from './Auth';
export const EncryptionsAccessLogDetailTypeResource = authResource({
    path: '/encryptions/:encryptionId/accesslogs/detailtypes/:detailTypeId?',
    schema: EncryptionsAccessLogDetailTypeEntity
});
